const createOrUpdateUserGuardianDetailsGraphQlMutation = (
  withMutation = true
): { mutation: string; type: string } => {
  const failureFields = `
      failure_response {
        res_status
        response
      }
    `;

  const successFields = `
      completion_percentage
    `;

  const mutation = `create_or_update_user_guardian_details(user_guardian_details_input: $user_guardian_details_input) {
          ${successFields}
          ${failureFields}
        }`;

  if (withMutation)
    return {
      mutation: `
      mutation CreateOrUpdateUserGuardianDetails($user_guardian_details_input: UserGuardianDetailsInput!) {
        ${mutation}
      }
    `,
      type: 'UserGuardianDetailsInput!'
    };
  else return { mutation, type: 'UserGuardianDetailsInput!' };
};

export { createOrUpdateUserGuardianDetailsGraphQlMutation };
